import { createRoot } from 'react-dom/client'
import * as styles from '@common/EmbedHome.module.scss'
import App from './App'

document.addEventListener('DOMContentLoaded', function () {
	const searchParams = new URLSearchParams(window.location.search)
	const lang = document.documentElement.lang || 'ca'
	const preview = searchParams.get('preview') === '1'
	const slug = searchParams.get('slug')
	const containers = document.querySelectorAll('.embed-mapa-catalunya-immigracio')

	// 1. Creem l'IntersectionObserver
	const observer = new IntersectionObserver(
		(entries, observer) => {
			entries.forEach((entry) => {
				// Si el contenidor del mapa és visible
				if (entry.isIntersecting) {
					const container = entry.target

					// Recuperem les dades específiques d'aquest contenidor
					const embedHome = searchParams.get('embed-home') === '1' || container.dataset.embedHome === '1'
					if (embedHome) {
						container.classList.add(styles.containerHome)
					}

					// 2. Renderitzem l'App de React només per a aquest mapa
					const root = createRoot(container)
					root.render(
						<App
							lang={lang}
							preview={preview}
							embedHome={embedHome}
							slug={slug || container.dataset.slug || null}
						/>,
					)

					// 3. Deixem de vigilar aquest contenidor perquè ja s'ha carregat
					observer.unobserve(container)
				}
			})
		},
		{
			// Comença a renderitzar el mapa 300px abans que l'usuari hi arribi fent scroll
			rootMargin: '300px',
		},
	)

	// 4. En lloc de renderitzar directament, assignem cada contenidor a l'observer
	containers.forEach((container) => {
		observer.observe(container)
	})
})
